// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.portal-topbar {
    background-color: var(--titlebar-bg-color);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    height: 3.5em;
    z-index: 201;
    display: flex;
    align-items: center;
}

span.portal-topbar-text {
    color: var(--titlebar-text-color);
    padding: 0 1.5em 0 0.5em;
    font-weight: bold;
}

img.portal-logo {
    width: auto;
    height: 3.5em;
    flex: 0 0 auto;
}

input.portal-search-field {
    flex: 1 0 auto;
    height: 2em;
    max-width: 70ch;
    background-color: var(--input-bg-color);
    border: 1px solid var(--border-color);
}

span.portal-topbar-spacer {
    flex: 1 1 auto;
}

div.portal-topbar div.AppMenu {
    flex: 0 0 auto;
    height: 3.5em;
}

div.portal-topbar div.AppMenu div.appmenu-menu-container {
    height: calc(100vh - 5.75em);
    background-color: var(--app-menu-bg-color);
}

div.portal-topbar div.AppMenu ul.appmenu-menu li:last-child {
    border-bottom: 1px solid var(--app-menu-text-color);
}

span.portal-menu-button {
    margin-right: 1em;
    width: 19em;
    display: inline-block;
}

span.portal-menu-label {
    font-weight: bold;
    color: var(--titlebar-text-color);
}

.portal-menu-icon {
    color: var(--titlebar-text-color);
    padding: 0.25em;
    margin: 0 1em;
    border: 2px solid var(--titlebar-text-color);
}


div.portal-body {
    background-color: var(--container-bg-color);
    position: fixed;
    left: 0;
    right: 0;
    bottom: 2.25em;
    top: 3.5em;
    z-index: 200;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
}

div.portal-body-menuvisible div.ThemeList {
    margin-right: 20em;
}

div.portal-body div.ThemeList {
    flex: 1 1 auto;
}

div.portal-bottombar {
    background-color: var(--titlebar-bg-color);
    color: var(--titlebar-text-color);
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 3em;
    font-size: 75%;
    z-index: 200;
    display: flex;
    align-items: center;
}

div.portal-bottombar-user {
    flex: 0 0 auto;
    padding: 0 0.5em;
}

div.portal-bottombar-user > span.icon {
    margin-right: 0.5em;
}

div.portal-bottombar-links {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 0.5em;
}

div.portal-bottombar-links > a {
    color: var(--titlebar-text-color);
    padding: 0 0.5em;
}

div.portal-bottombar-links > a:not(:last-child) {
    border-right: 1px solid var(--titlebar-text-color);
}
`, "",{"version":3,"sources":["webpack://./qwc2/plugins/style/Portal.css"],"names":[],"mappings":"AAAA;IACI,0CAA0C;IAC1C,eAAe;IACf,OAAO;IACP,QAAQ;IACR,MAAM;IACN,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,uCAAuC;IACvC,qCAAqC;AACzC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,aAAa;IACb,4CAA4C;AAChD;;;AAGA;IACI,2CAA2C;IAC3C,eAAe;IACf,OAAO;IACP,QAAQ;IACR,cAAc;IACd,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0CAA0C;IAC1C,iCAAiC;IACjC,eAAe;IACf,OAAO;IACP,QAAQ;IACR,SAAS;IACT,WAAW;IACX,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,kDAAkD;AACtD","sourcesContent":["div.portal-topbar {\r\n    background-color: var(--titlebar-bg-color);\r\n    position: fixed;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    height: 3.5em;\r\n    z-index: 201;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\nspan.portal-topbar-text {\r\n    color: var(--titlebar-text-color);\r\n    padding: 0 1.5em 0 0.5em;\r\n    font-weight: bold;\r\n}\r\n\r\nimg.portal-logo {\r\n    width: auto;\r\n    height: 3.5em;\r\n    flex: 0 0 auto;\r\n}\r\n\r\ninput.portal-search-field {\r\n    flex: 1 0 auto;\r\n    height: 2em;\r\n    max-width: 70ch;\r\n    background-color: var(--input-bg-color);\r\n    border: 1px solid var(--border-color);\r\n}\r\n\r\nspan.portal-topbar-spacer {\r\n    flex: 1 1 auto;\r\n}\r\n\r\ndiv.portal-topbar div.AppMenu {\r\n    flex: 0 0 auto;\r\n    height: 3.5em;\r\n}\r\n\r\ndiv.portal-topbar div.AppMenu div.appmenu-menu-container {\r\n    height: calc(100vh - 5.75em);\r\n    background-color: var(--app-menu-bg-color);\r\n}\r\n\r\ndiv.portal-topbar div.AppMenu ul.appmenu-menu li:last-child {\r\n    border-bottom: 1px solid var(--app-menu-text-color);\r\n}\r\n\r\nspan.portal-menu-button {\r\n    margin-right: 1em;\r\n    width: 19em;\r\n    display: inline-block;\r\n}\r\n\r\nspan.portal-menu-label {\r\n    font-weight: bold;\r\n    color: var(--titlebar-text-color);\r\n}\r\n\r\n.portal-menu-icon {\r\n    color: var(--titlebar-text-color);\r\n    padding: 0.25em;\r\n    margin: 0 1em;\r\n    border: 2px solid var(--titlebar-text-color);\r\n}\r\n\r\n\r\ndiv.portal-body {\r\n    background-color: var(--container-bg-color);\r\n    position: fixed;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 2.25em;\r\n    top: 3.5em;\r\n    z-index: 200;\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow-y: auto;\r\n}\r\n\r\ndiv.portal-body-menuvisible div.ThemeList {\r\n    margin-right: 20em;\r\n}\r\n\r\ndiv.portal-body div.ThemeList {\r\n    flex: 1 1 auto;\r\n}\r\n\r\ndiv.portal-bottombar {\r\n    background-color: var(--titlebar-bg-color);\r\n    color: var(--titlebar-text-color);\r\n    position: fixed;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    height: 3em;\r\n    font-size: 75%;\r\n    z-index: 200;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\ndiv.portal-bottombar-user {\r\n    flex: 0 0 auto;\r\n    padding: 0 0.5em;\r\n}\r\n\r\ndiv.portal-bottombar-user > span.icon {\r\n    margin-right: 0.5em;\r\n}\r\n\r\ndiv.portal-bottombar-links {\r\n    flex: 1 1 auto;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n    padding: 0 0.5em;\r\n}\r\n\r\ndiv.portal-bottombar-links > a {\r\n    color: var(--titlebar-text-color);\r\n    padding: 0 0.5em;\r\n}\r\n\r\ndiv.portal-bottombar-links > a:not(:last-child) {\r\n    border-right: 1px solid var(--titlebar-text-color);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
